import { SeasonGroup } from '@features/marketable/marketable.enums'

const sortItemsBySeasonShortName = (prev, current) =>
  prev.seasonShortName < current.seasonShortName ? 1 : -1

const sortGroupByLabel = (prev, current) => (prev.label > current.label ? 1 : -1)

export const toArray = (obj) =>
  Object.values(obj)
    .map((mapObj: any) => ({ ...mapObj, items: mapObj.items.sort(sortItemsBySeasonShortName) }))
    .sort(sortGroupByLabel)

export const getGroupName = (grouping) =>
  grouping === SeasonGroup.Current ? 'MTR_COMMON_CURRENT_SEASON' : 'MTR_COMMON_PREVIOUS_SEASONS'

export const groupingOptions = (prev, current) => ({
  ...prev,
  [getGroupName(current.grouping)]: {
    label: getGroupName(current.grouping),
    items: [...((prev[getGroupName(current.grouping)] || {}).items || []), current],
  },
})
